import { useState } from "react";
import { analyticsConfigured, initializeAnalytics, setAnalyticsConsent } from "../../lib/analytics";

export function ConsentBanner({ locale = "en" }: { locale?: "en" | "fa" }) {
  const [visible, setVisible] = useState(() => analyticsConfigured && typeof window !== "undefined" && localStorage.getItem("itr_analytics_consent") === null);
  if (!visible) return null;

  const choose = (granted: boolean) => {
    setAnalyticsConsent(granted);
    if (granted) initializeAnalytics();
    setVisible(false);
  };

  return (
    <aside className="consent-banner" aria-label={locale === "fa" ? "تنظیمات تحلیل بازدید" : "Analytics preferences"}>
      <p><strong>{locale === "fa" ? "تنظیمات تحلیل بازدید" : "Analytics preferences"}</strong><span>{locale === "fa" ? "ابزارهای اختیاری تحلیل به بهبود سایت کمک می‌کنند. می‌توانید آنها را بپذیرید یا رد کنید." : "Optional analytics help us improve the website. You can accept or decline them."}</span></p>
      <div><button type="button" onClick={() => choose(false)}>{locale === "fa" ? "رد کردن" : "Decline"}</button><button className="button" type="button" onClick={() => choose(true)}>{locale === "fa" ? "پذیرفتن" : "Accept analytics"}</button></div>
    </aside>
  );
}
